import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import isoWeeksInYear from 'dayjs/plugin/isoWeeksInYear';
import isLeapYear from 'dayjs/plugin/isLeapYear';
dayjs.extend(isoWeek);
dayjs.extend(isoWeeksInYear);
dayjs.extend(isLeapYear);
const precisionRankRecord = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5,
};
export function generateDatePickerColumns(selected, min, max, precision, unit) {
    const ret = [];
    if (!selected) {
        selected = new Array(5).fill('0');
    }
    if (selected.length < 5) {
        for (let i = selected.length; i < 5; i++) {
            selected.push('0');
        }
    }
    const thisYear = new Date().getFullYear();
    const minVal = min || new Date(new Date().setFullYear(thisYear - 10));
    const maxVal = max || new Date(new Date().setFullYear(thisYear + 10));
    const precisionVal = precision || 'day';
    const minYear = minVal.getFullYear();
    const minMonth = minVal.getMonth() + 1;
    const minDay = minVal.getDate();
    const minHour = minVal.getHours();
    const minMinute = minVal.getMinutes();
    const minSecond = minVal.getSeconds();
    const maxYear = maxVal.getFullYear();
    const maxMonth = maxVal.getMonth() + 1;
    const maxDay = maxVal.getDate();
    const maxHour = maxVal.getHours();
    const maxMinute = maxVal.getMinutes();
    const maxSecond = maxVal.getSeconds();
    const rank = precisionRankRecord[precisionVal];
    const selectedYear = parseInt(selected[0]);
    const firstDayInSelectedMonth = dayjs(convertStringArrayToDate([selected[0], selected[1], '1']));
    const selectedMonth = parseInt(selected[1]);
    const selectedDay = parseInt(selected[2]);
    const selectedHour = parseInt(selected[3]);
    const selectedMinute = parseInt(selected[4]);
    const isInMinYear = selectedYear === minYear;
    const isInMaxYear = selectedYear === maxYear;
    const isInMinMonth = isInMinYear && selectedMonth === minMonth;
    const isInMaxMonth = isInMaxYear && selectedMonth === maxMonth;
    const isInMinDay = isInMinMonth && selectedDay === minDay;
    const isInMaxDay = isInMaxMonth && selectedDay === maxDay;
    const isInMinHour = isInMinDay && selectedHour === minHour;
    const isInMaxHour = isInMaxDay && selectedHour === maxHour;
    const isInMinMinute = isInMinHour && selectedMinute === minMinute;
    const isInMaxMinute = isInMaxHour && selectedMinute === maxMinute;
    const generateColumn = (from, to, precision) => {
        const column = [];
        for (let i = from; i <= to; i++) {
            column.push(i);
        }
        return column;
    };
    if (rank >= precisionRankRecord.year) {
        const lower = minYear;
        const upper = maxYear;
        const years = generateColumn(lower, upper, 'year');
        ret.push(years.map(v => {
            return {
                label: unit ? v.toString() + '年' : v.toString(),
                value: v.toString(),
            };
        }));
    }
    if (rank >= precisionRankRecord.month) {
        const lower = isInMinYear ? minMonth : 1;
        const upper = isInMaxYear ? maxMonth : 12;
        const months = generateColumn(lower, upper, 'month');
        ret.push(months.map(v => {
            return {
                label: unit ? v.toString() + '月' : v.toString(),
                value: v.toString(),
            };
        }));
    }
    if (rank >= precisionRankRecord.day) {
        const lower = isInMinMonth ? minDay : 1;
        const upper = isInMaxMonth ? maxDay : firstDayInSelectedMonth.daysInMonth();
        const days = generateColumn(lower, upper, 'day');
        ret.push(days.map(v => {
            return {
                label: unit ? v.toString() + '日' : v.toString(),
                value: v.toString(),
            };
        }));
    }
    if (rank >= precisionRankRecord.hour) {
        const lower = isInMinDay ? minHour : 0;
        const upper = isInMaxDay ? maxHour : 23;
        const hours = generateColumn(lower, upper, 'hour');
        ret.push(hours.map(v => {
            return {
                label: unit ? v.toString() + '时' : v.toString(),
                value: v.toString(),
            };
        }));
    }
    if (rank >= precisionRankRecord.minute) {
        const lower = isInMinHour ? minMinute : 0;
        const upper = isInMaxHour ? maxMinute : 59;
        const minutes = generateColumn(lower, upper, 'minute');
        ret.push(minutes.map(v => {
            return {
                label: unit ? v.toString() + '分' : v.toString(),
                value: v.toString(),
            };
        }));
    }
    if (rank >= precisionRankRecord.second) {
        const lower = isInMinMinute ? minSecond : 0;
        const upper = isInMaxMinute ? maxSecond : 59;
        const seconds = generateColumn(lower, upper, 'second');
        ret.push(seconds.map(v => {
            return {
                label: unit ? v.toString() + '秒' : v.toString(),
                value: v.toString(),
            };
        }));
    }
    return ret;
}
export function convertDateToStringArray(date) {
    if (!date)
        return [];
    return [
        date.getFullYear().toString(),
        (date.getMonth() + 1).toString(),
        date.getDate().toString(),
        date.getHours().toString(),
        date.getMinutes().toString(),
        date.getSeconds().toString(),
    ];
}
export function convertStringArrayToDate(value) {
    const yearString = value[0] ?? '1900';
    const monthString = value[1] ?? '1';
    const dateString = value[2] ?? '1';
    const hourString = value[3] ?? '0';
    const minuteString = value[4] ?? '0';
    const secondString = value[5] ?? '0';
    return new Date(parseInt(yearString), parseInt(monthString) - 1, parseInt(dateString), parseInt(hourString), parseInt(minuteString), parseInt(secondString));
}
